export function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-border bg-background py-6 ${className}`} data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display text-3xl font-extrabold uppercase tracking-tight text-foreground md:text-5xl">{t}</span>
            <span className="text-cyan text-3xl md:text-5xl">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
